import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aa8e83e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1))
const _hoisted_3 = { class: "inline-block px-4 pt-5 pb-4 overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6" }
const _hoisted_4 = { class: "sm:flex sm:items-start" }
const _hoisted_5 = { class: "mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-[#F3F4F6] sm:mx-0 sm:h-10 sm:w-10" }
const _hoisted_6 = { class: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" })
], -1))
const _hoisted_8 = { class: "mt-5" }
const _hoisted_9 = { class: "rounded-md img-upload__wrap" }
const _hoisted_10 = { class: "upload-wrap" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "block mx-auto mb-4",
  src: "/assets/images/img-placeholder.svg"
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createTextVNode("Select a file "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400" }, "or drag and drop")
], -1))
const _hoisted_13 = { for: "addon-upload" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 0,
  class: "text-xs text-gray-500"
}
const _hoisted_16 = { class: "mt-5 sm:mt-4 sm:flex sm:flex-row-reverse" }
const _hoisted_17 = ["disabled"]

import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import http from '@/axios'
import { ref } from "vue";
import { PlusIcon } from "@heroicons/vue/24/outline";
import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue';
import AuthService from "@/classes/AuthService";

import Storage from '@/helpers/storage';

 
export default /*#__PURE__*/_defineComponent({
  __name: 'UploadIDModal',
  props: {
    title: {
        default: '',
        type: String
    },
    type: {
        type: String
    },
    patientId: {
        type: Number
    },
    dialog: {
        default: false,
        type: Boolean
    },
    importRoute: {
        default: null,
        type: String
    },
},
  emits: ["onClose"],
  setup(__props, { emit: __emit }) {

const TOKEN_PARAM_STRING = AuthService.getHybrainTokenQueryString();

 const storage = new Storage();

const emit = __emit

const props = __props;

const file         = ref(['image/*']);
const loader      = ref(false);
const showError   = ref(false);
const errorMsg    = ref(null);
const showSuccess = ref(false);

const handleFileUpload = (event: any) : void => {
    file.value = event.target.files
}

const submitFile = async () => {
    loader.value = true;

    const formData = new FormData()
    
    formData.append('file', file.value[0])

    const route = `${props.importRoute}?patient_id=${props.patientId}&type=${props.type}&${TOKEN_PARAM_STRING}`

    try {
        const {data} = await http.post(route, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        const image = data.response.image
        const patient = JSON.parse(storage.get('patient'));

        if (props.type == 'sr_id') {
            patient.senior_citizen_id_base_64 = image;
        } else if (props.type == 'pwd_id') {
            patient.pwd_id_base_64 = image;
        }

        storage.set('patient', JSON.stringify(patient))

        loader.value = false;
        showSuccess.value = true

        setTimeout(() => window.location.reload(), 1000);

    } catch ({response: {status, data: {message}} = {}}) {
        loader.value = false;
        showError.value = true;
        errorMsg.value = message;

        if(status === 401) {
            window.location.replace('/login');
        }
    }
}
 
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: __props.dialog
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          class: "fixed inset-0 z-10 overflow-y-auto",
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onClose')))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" })
                ]),
                _: 1
              }),
              _hoisted_2,
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_unref(PlusIcon), {
                          class: "w-6 h-6 text-primary--800",
                          "aria-hidden": "true"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_unref(DialogTitle), {
                          as: "h3",
                          class: "text-lg font-bold leading-6 text-primary--800"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(__props.title), 1)
                          ]),
                          _: 1
                        }),
                        _hoisted_7
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _hoisted_11,
                          _hoisted_12,
                          _createElementVNode("label", _hoisted_13, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(file.value, (fn, index) => {
                              return (_openBlock(), _createElementBlock("span", {
                                class: "text-sm text-gray-400",
                                key: index
                              }, [
                                _createTextVNode(_toDisplayString(fn.name) + " ", 1),
                                (index != file.value.length - 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, ", "))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128)),
                            (file.value.length === 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, " Max File Size: 10MB | File Types: PNG, JPEG, JPG "))
                              : _createCommentVNode("", true),
                            _createElementVNode("input", {
                              type: "file",
                              onChange: handleFileUpload,
                              name: 'file_upload',
                              accept: "image/png, image/JPEG, image/JPG,"
                            }, null, 32)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("button", {
                        type: "button",
                        disabled: loader.value,
                        class: "inline-flex justify-center w-full px-4 py-2 font-medium text-white rounded-md shadow-sm bg-primary-500 sm:ml-3 sm:w-auto sm:text-sm border-primary-500 disabled:opacity-25 focus:ring-1 focus:ring-offset-1",
                        onClick: submitFile
                      }, " Upload ", 8, _hoisted_17),
                      _createElementVNode("button", {
                        type: "button",
                        class: "inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm bg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary sm:mt-0 sm:w-auto sm:text-sm",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClose'))),
                        ref: "cancelButtonRef"
                      }, " Cancel ", 512)
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    (loader.value)
      ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(ErrorModal, {
      width: "w-[548px]",
      title: "Error",
      "action-text": "Close",
      "cancel-text": "Go back",
      show: showError.value,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (showError.value = false)),
      onConfirm: _cache[3] || (_cache[3] = ($event: any) => (showError.value = false))
    }, {
      content: _withCtx(() => [
        _createTextVNode(_toDisplayString(errorMsg.value), 1)
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(SuccessModal, {
      show: showSuccess.value,
      onCancel: _cache[4] || (_cache[4] = ($event: any) => (showSuccess.value = false)),
      onConfirm: _cache[5] || (_cache[5] = ($event: any) => (showSuccess.value = false)),
      "action-text": "Close",
      title: `${__props.title} Upload`,
      content: "Upload success!"
    }, null, 8, ["show", "title"])
  ], 64))
}
}

})